import React, { useContext } from "react";
import Button from "~/components/parts/Button";
import { ApplicationFormContext } from ".";
import { SubscriptionDispatchContext } from "../../..";

const Buttons = () => {
  const { submissionError, submissionLoading } = useContext(
    ApplicationFormContext,
  );

  const dispatch = useContext(SubscriptionDispatchContext);

  const handleCancel = () => {
    dispatch({ type: "cancel_form" });
    document?.getElementById("tabs-subscription")?.scrollTo(0, 0);
  };

  return (
    <>
      <div className="flex w-full justify-end gap-4">
        <Button
          className="my-auto w-[100px] bg-transparent p-2 text-sm text-red-800 outline-red-100 transition hover:bg-slate-50 disabled:bg-transparent disabled:text-gray-400 disabled:hover:bg-transparent"
          disabled={submissionLoading}
          onClick={handleCancel}
          type="button"
        >
          Cancel
        </Button>
        <Button
          className="my-auto w-[200px] bg-blue-500 p-2 text-sm text-white shadow-sm hover:bg-blue-500 disabled:bg-blue-200 disabled:text-white disabled:shadow-none"
          disabled={submissionLoading}
          type="submit"
        >
          Submit
        </Button>
      </div>
      {submissionError && (
        <div className="my-auto -mt-4 text-right text-sm text-red-900">
          There was an error submitting your application.
        </div>
      )}
    </>
  );
};

export default Buttons;
